import { QueryClient } from '@tanstack/react-query';
import { RequestParamsGetProducts } from './Product/types';
import { Sales } from '@inhouse-market/sdk';
import { BillingRulesParams } from './Billing/useBillingRules';
import { FiltersChurn } from './Churn/types';

const queryClient = new QueryClient();

export const queryKeys = {
    GET_SETTINGS: ['GET_SETTINGS'],
    GET_LOGS_RELOAD_SETTINGS: ['GET_LOGS_RELOAD_SETTINGS'],
    GET_CLIENTS_PAGINATED: (email: string | undefined) => [
        'GET_CLIENTS_PAGINATED',
        email,
    ],
    GET_SHOPMANAGER_TOTEMS: ['GET_SHOPMANAGER_TOTEMS'],
    GET_STORES_V2: ['GET_STORES_V2'],
    GET_STORE_LOCKS: (params: Record<string, any>) => [
        'GET_STORE_LOCKS',
        params,
    ],
    GET_ME: ['GET_ME'],
    GET_PRODUCTS_PAGINATED: (params?: RequestParamsGetProducts) => [
        'GET_PRODUCTS_PAGINATED',
        params,
    ],
    GET_AUTH_STORE: () => ['GET_AUTH_STORE'],
    SALES: (params: Sales.SalesListByTransactionRequest) => [, 'sales', params] as const,
    SALES_BY_TRANSACTION: (params: Sales.SalesListByTransactionRequest) =>
        [, 'sales-by-transaction', params] as const,
    EXTRA_INFO: (params: Sales.SalesGetExtraInfoRequest) =>
        [, 'extra-info', params] as const,
    SUMMARY: (params: Sales.SalesGetExtraInfoSummaryRequest) => [, 'summary', params] as const,
    SALE: (id: number) => ['sale', id] as const,
    STORE_GROUPS: ['STORE_GROUPS'],
    STORES_BY_GROUP_ROOT: ['STORES_BY_GROUP'],
    STORES_BY_GROUP: (name: string) => ['STORES_BY_GROUP', name],
    SUMMARY_CHURN: ['SUMMARY_CHURN'],
    CHURNS: (params?: FiltersChurn) => ['CHURNS', params],
    CHURN_PARAMS: ['CHURN_PARAMS'],
    BILLING_RULES: (params: BillingRulesParams) => ['BILLING_RULES', params],
    GLOBAL_BILLING_RULES: (shopManagerId: number) => ['GLOBAL_BILLING_RULES', shopManagerId],
};

export default queryClient;
